"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _utils = require("../utils");

var _mixins = require("../mixins");

var _buttonMixin = require("./buttonMixin");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var mixins = (0, _utils.combineMixins)(_buttonMixin.buttonMixin, _mixins.marginMixin, _mixins.widthMixin, _mixins.minWidthMixin, _mixins.flexboxMixin, _mixins.displayMixin);
var ButtonBase = (0, _context.styledWithTheme)('button', {
  shouldForwardProp: (0, _utils.filterPropsFromPropTypes)(mixins.propTypes, {
    propsToForward: ['disabled'],
    filterInvalidHTML: true
  })
})(_templateObject(), mixins);
var ButtonBaseWithDocs = (0, _stencilReactDesc.describe)(ButtonBase).description("Used to communicate an action that's initiated by clicking or tapping.");
ButtonBaseWithDocs.propTypes = (0, _objectSpread2.default)({}, mixins.describedPropTypes, {
  children: _stencilReactDesc.PropTypes.node.description('Displayed inside the clickable area of the button.')
});
ButtonBaseWithDocs.defaultProps = {
  type: 'button',
  display: 'flex'
};
var Button = (0, _utils.withTestAttributes)({
  component: 'StencilReactButton'
})(ButtonBaseWithDocs);
Button.displayName = 'Button';
var _default = Button;
exports.default = _default;